<template>
    <div
        class="selection-box"
    >
        <b-form-checkbox-group
            :class="{'readonly': readonly}"
            :checked="selected"
            :autofocus="autofocus"
            :disabled="disabledData || readonly"
            :options="buttonOptions"
            :required="required"
            buttons
            @change="selection"
        />
    </div>
</template>

<script>
    /**
     * @group Inputs
     * A component that allows for selecting from a range of button options.
     */
    export default {
        name: 'SelectionBox',
        model: {
            prop: 'selected',
            event: 'selection-box-input',
        },
        props: {
            /**
             * Sets autofocus on component, defaults to false.
             */
            autofocus: {
                type: Boolean,
                required: false,
                // `false`
                default: false
            },
            /**
             * An array of items to display in the box component.
             */
            buttonOptions: {
                type: Array,
                required: false,
                // `[]`
                default() {
                    return [];
                }
            },
            /**
             * The array of the current value. Used for the `v-model` binding.
             */
            selected: {
                type: Array,
                required: true,
            },
            /**
             * Allows no option to be selected, defaults to true.
             */
            allowEmpty: {
                type: Boolean,
                required: false,
                // `true`
                default: true
            },
            /**
             * Sets the state of the component to disabled, defaults to false.
             */
            disabled: {
                type: Boolean,
                required: false,
                // `false`
                default: false
            },
            /**
            * Sets the state of the component to readonly, defaults to false
             */
            readonly: {
                type: Boolean,
                required: false,
                // `false`
                default: false
            },
            /**
             * Allow multiple options to be selected, defaults to false.
             */
            multiple: {
                type: Boolean,
                required: false,
                // `false`
                default: false
            },
            /**
             * Sets selection to be required
             */
            required: {
                type: Boolean,
                required: false,
                // `false`
                default: false
            },
            /**
             * Sets passed items to be pre-selected
             */
            preSelected: {
                type: Array,
                required: false,
                // `[]`
                default() {
                    return [];
                }
            },
        },
        data() {
            return {
                disabledData: this.disabled
            };
        },
        created() {
            if (!this.selected.length && !this.allowEmpty && this.buttonOptions.length) {
                this.$emit('selection-box-input', [this.buttonOptions[0].value]);
            }
        },
        methods: {
            selection($event) {
                let selection = $event;
                if (!this.multiple) {
                    selection = selection.length ? [selection.pop()] : selection;
                }

                if (!selection.length && !this.allowEmpty) {
                    this.$emit('selection-box-input', [this.selected[0]]);

                    return;
                }

                this.$emit('selection-box-input', selection);
            }
        }
    };
</script>
